<template>
  <div class="breadcrumb is-print-hide">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path }">{{ firstName }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="parent" v-for="(key, index) in parent" :to="key.belong" :key="index">
        {{ key.title }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import Vue from 'vue';
export default {
  props: ['firstName', 'secondName'],
  computed: {
    title() {
      // 渲染当前面包屑内容
      return this.secondName || this.$route.meta.title;
    },
    path() {
      // 渲染path
      return this.$route.meta.belong;
    },
    // 支持超过两级的面包屑，需要在路由里面去配置，belong是为了兼容之前代码，为第一级面包屑，parent里面可配置其余
    parent() {
      return this.$route.meta.parent;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  // padding-top: 12px;
  padding-bottom: 12px;
  .el-breadcrumb {
    height: 12px;
    line-height: 12px;
    /deep/.el-breadcrumb__separator {
      margin: 0 2px;
    }
  }
}
</style>
